import lengthEndAdornment from "constants/lenghtEndAdornment";
import CreateProductAttributesFormFields from "./CreateProductAttributesFormFields";

const fields = [];

export default function MicrosurfacingForm() {
  return <CreateProductAttributesFormFields fields={fields} />;
}
